import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND || 'https://babralauatapi-d9abe9h8frescchd.centralindia-01.azurewebsites.net',
  headers: { 
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  timeout: 15000 // 15 second timeout
});

// Add detailed request logging
api.interceptors.request.use(
  (config) => {
    console.log('📤 API REQUEST:', {
      method: config.method?.toUpperCase(),
      url: config.baseURL + config.url,
      hasData: !!config.data,
      headers: config.headers
    });
    return config;
  },
  (error) => {
    console.error('📤 REQUEST SETUP ERROR:', error);
    return Promise.reject(error);
  }
);

// Add detailed response logging
api.interceptors.response.use(
  (response) => {
    console.log('📥 API RESPONSE SUCCESS:', {
      status: response.status,
      url: response.config.url,
      hasData: !!response.data
    });
    return response;
  },
  (error) => {
    console.error('📥 API RESPONSE ERROR:', {
      status: error.response?.status,
      statusText: error.response?.statusText,
      url: error.config?.url,
      message: error.message,
      data: error.response?.data
    });
    return Promise.reject(error);
  }
);

export const searchPlaces = (query) => {
  return api.post('/asto/places/search', { 
    query: query,
    country: 'IN',
    types: ['(cities)'],
    language: 'en'
  });
};

export const getPlaceDetails = (placeId) => {
  return api.get(`/asto/places/details/${placeId}`);
};

export const sendMessage = (text) => api.post('/asto/message', { message: text });
export const googleSignup = (googleToken, profile = {}) => api.post('/asto/signup', { token: googleToken, profile });
export const googleLogin = (googleToken) => api.post('/asto/login', { token: googleToken });
export const getUserProfile = (userId) => api.get(`/asto/profile/${userId}`);


// ✅ NEW: Credit Management APIs
export const getUserCredits = (userId) => api.get(`/asto/credits/${userId}`);

export const deductCredits = (userId, amount, reason = 'Question asked') => {
  return api.post(`/asto/credits/${userId}/deduct`, {
    amount: amount,
    reason: reason
  });
};

export const addCredits = (userId, amount, reason = 'Credits purchased', packageInfo = null) => {
  return api.post(`/asto/credits/${userId}/add`, {
    amount: amount,
    reason: reason,
    packageInfo: packageInfo
  });
};

export const getCreditHistory = (userId) => api.get(`/asto/credits/${userId}/history`);
